import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  getAssessmentAudits,
  setApplicationAssessment,
} from "../adminApi";
import { AssessDto } from "../models";

export const setApplicationAssessmentThunk = createAsyncThunk(
  "setApplicationAssessment",
  async (payload: AssessDto) => {
    let response: any;
    await setApplicationAssessment(payload)
      .then((data) => {
        response = data;
      })
      .catch((error) => {
        response = error.response.data;
      });
    return response;
  }
);

export const getAssessmentAuditsThunk = createAsyncThunk(
  "getAssessmentAudits",
  async () => {
    let response: any;
    await getAssessmentAudits()
      .then((data) => {
        response = data;
      })
      .catch((error) => {
        response = error.response.data;
      });
    return response;
  }
);